import { useDispatch, useSelector } from 'react-redux';
import {
  AppDispatch,
  DashboardRequestActions,
  dashboardsSelectors,
  fullstorySelectors,
} from '@fullstory/redux';
import { useEffect } from 'react';
import { useFlags } from '@fullstory/react-hooks';
import { Flag } from '@fullstory/proto/fs/shared/flags';

const { getOrgId, getUserInfo } = fullstorySelectors;
const {
  dashboardList,
  getRecentDashboards,
  getStarredDashboards,
  getOtherDashboards,
  dashboardsLoading,
} = dashboardsSelectors;

/**
 * Fetches and partitions dashboard types.
 * @param preventFetch Optionally prevent an additional fetch.  Previous data may still be returned from redux.
 */
export const useAllDashboardTypes = (preventFetch?: boolean) => {
  const orgId = useSelector(getOrgId);
  const dispatch = useDispatch<AppDispatch>();
  const { email } = useSelector(getUserInfo);
  const flags = useFlags();
  useEffect(() => {
    if (!preventFetch && flags.hasBit(Flag.FeatDashboards)) {
      dispatch(DashboardRequestActions.fetchInitialDashboards(orgId, flags));
      dispatch(
        DashboardRequestActions.fetchAllDashboard(
          { orgId, email, omitSeatSettings: false },
          email,
          flags,
        ),
      );
    }
  }, [dispatch, preventFetch, orgId, email, flags]);

  return {
    dashboards: useSelector(dashboardList),
    starredDashboards: useSelector(getStarredDashboards),
    recentDashboards: useSelector(getRecentDashboards),
    otherDashboards: useSelector(getOtherDashboards),
    dashboardsLoading: useSelector(dashboardsLoading),
  };
};
